import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=c73ff7c4&"
import script from "./Incidents.vue?vue&type=script&lang=js&"
export * from "./Incidents.vue?vue&type=script&lang=js&"
import style0 from "./Incidents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports